import { data } from '../../svg/Fuel/data';
import { makeIcon } from '../makeIcon';

export const Fuel = makeIcon(data, 'fuel', 'Fuel');

export default Fuel;
